import { AlertTriangle, RotateCw, X } from "lucide-react";
import { useTranslation } from "react-i18next";

// Одно окно на все отказы карточной подсистемы.
//
// Раньше отказ показывался тостом: он уходит через три секунды, унося с собой
// единственное объяснение, а человек остаётся перед экраном, на котором ничего
// не изменилось. Хуже того, в тост попадал текст, написанный для интегратора.
//
// Теперь текст приходит с бэкенда уже человеческим (cards_api._PROVIDER_MESSAGES),
// а окно решает только одно: что предложить дальше. Признак retryable даёт
// бэкенд — он знает, лечится отказ повтором или действием человека.
//
// Технический текст провайдера сюда НЕ попадает никогда: он остаётся в
// providerMessage и в логах, где нужен поддержке.
const CardsErrorDialog = ({ error, onClose, onRetry, extraAction }) => {
  const { t } = useTranslation();

  if (!error) return null;

  const retryable = Boolean(error.retryable) && typeof onRetry === "function";

  return (
    <div
      className="fixed inset-0 z-[95] flex items-center justify-center bg-black/60 p-4 backdrop-blur-[2px]"
      role="alertdialog"
      aria-modal="true"
      data-testid="cards-error-dialog"
    >
      <div className="lp-veil lp-veil--edged rounded-[22px] relative w-full max-w-md p-6 text-center">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 inline-flex h-8 w-8 items-center justify-center rounded-full text-muted-foreground"
          aria-label={t("cards.err_ok")}
        >
          <X className="h-4 w-4" />
        </button>

        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-destructive/10 ring-1 ring-inset ring-destructive/35">
          <AlertTriangle className="h-6 w-6 text-destructive-fg" />
        </div>

        <h3 className="mt-4 text-lg font-semibold text-foreground">{t("cards.err_title")}</h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground/80">{error.message}</p>

        <div className="mt-5 space-y-2">
          {retryable && (
            <button
              type="button"
              onClick={onRetry}
              className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-primary px-4 py-3.5 text-sm font-semibold text-primary-foreground"
              data-testid="cards-error-retry"
            >
              <RotateCw className="h-4 w-4" />
              {t("cards.retry")}
            </button>
          )}
          {extraAction && (
            <button
              type="button"
              onClick={extraAction.onClick}
              className={
                retryable
                  ? "w-full rounded-xl border border-[rgb(var(--lp-edge)/var(--lp-edge-a))] px-4 py-3 text-sm font-semibold text-link"
                  : "w-full rounded-xl bg-primary px-4 py-3.5 text-sm font-semibold text-primary-foreground"
              }
              data-testid="cards-error-extra"
            >
              {extraAction.label}
            </button>
          )}
          <button
            type="button"
            onClick={onClose}
            className={
              retryable || extraAction
                ? "w-full rounded-xl px-4 py-2.5 text-sm font-semibold text-muted-foreground"
                : "w-full rounded-xl border border-[rgb(var(--lp-edge)/var(--lp-edge-a))] px-4 py-3 text-sm font-semibold text-foreground"
            }
          >
            {t("cards.err_ok")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CardsErrorDialog;
